





































import Vue, { PropType } from "vue";
import { adaptHealthPocView } from "@/utils/healthPocViewAdapter";

type HealthPocPoint = ReturnType<typeof adaptHealthPocView>["weeklySteps"][number];

export default Vue.extend({
  name: "HealthWeeklyChart",
  props: {
    points: { type: Array as PropType<HealthPocPoint[]>, default: () => [] },
    historyAvailable: { type: Boolean, default: false }
  },
  computed: {
    maxValue(): number {
      return Math.max(0, ...this.points.filter(point => point.available).map(point => point.value));
    },
    hasMissingDays(): boolean {
      return !this.historyAvailable || this.points.some(point => !point.available);
    },
    historyNote(): string {
      if (this.historyAvailable) {
        return "Alguns dias não têm histórico disponível. Os zeros desses dias são apenas valores de exibição, não passos medidos.";
      }
      return "O histórico completo de sete dias não está disponível. Os zeros são apenas valores de exibição, não passos medidos.";
    }
  },
  methods: {
    barHeight(point: HealthPocPoint): string {
      if (!point.available || point.value <= 0 || this.maxValue <= 0) return "0%";
      return `${Math.max(5, (point.value / this.maxValue) * 100)}%`;
    },
    formatNumber(value: number): string {
      return new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format(value);
    }
  }
});
